import React from 'react';
import ActivateDeactivateGatewayComponent from './ActivateDeactivateGatewayComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getModel } from './selectors';
import * as actions from './actions';

const ActivateDeactivateGatewayContainer = (props) => {
    return <ActivateDeactivateGatewayComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const ActivateDeactivateGatewayContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivateDeactivateGatewayContainer);

export default React.memo(ActivateDeactivateGatewayContainerConn);
